// src/Routes/allRoutes.tsx
import React from "react";
import { Navigate } from "react-router-dom";

// dashbord / home layouts
import Home from "Pages/Home";
import Uniquewatch from "Pages/Home/Unique_watches/Index";
import ModernFashion from "Pages/Home/Modernfashion/Index";
import TrendFashion from "Pages/Home/TrendFashion/index";

// Catalog
import Catalog from "Pages/Catalog";
import CmsCatalog from "Pages/Catalog/CmsCatalog";

// shop
import ShopIndex from "Pages/Shop";
import Trackorder from "Pages/Shop/Trackorder";
import PaymentIndex from "Pages/Shop/Indexpayment";
import Review from "Pages/Shop/Review";
import Confirm from "Pages/Shop/Confirm";
import Orderhistory from "Pages/Shop/Orederhistory";
import Shopingcard from "Pages/Shop/Shopingcard";
import Checkout from "Pages/Shop/Checkout";
import WishList from "Pages/Shop/WhishList";

// pages / product / grid
import Defaultgrid from "Pages/Product/Grid/Default";
import ProductSidebar from "Pages/Product/Grid/ProductSideBar";
import RightSidebar from "Pages/Product/Grid/RightSidebar";
import Nosider from "Pages/Product/Grid/Nosidebar";

// pages / product / list
import Listdefault from "Pages/Product/List/Default";
import LeftsideBar from "Pages/Product/List/LeftSideBar";
import Leftrightsidebar from "Pages/Product/List/Leftrightsidebar";
import Listnoslider from "Pages/Product/List/Listnosider";

// pages / user
import MyAccount from "Pages/User/MyAccount";
import SignUp from "Pages/User/SignUp";
import Signin from "Pages/User/SignIn";
import Passwordreset from "Pages/User/Passwordreset";
import Passwordcreate from "Pages/User/Passwordcreate";
import Successmsg from "Pages/User/Successmsg";
import Verifyemail from "Pages/User/Verifyemail";
import Logout from "Pages/User/Logout";
import Error404 from "Pages/User/Error404";
import Error500 from "Pages/User/Error500";
import Comingsoon from "Pages/User/Comingsoon";

// pages / Email
import Blackfriday from "Pages/Product/Email Product/Blackfriday";
import Flashsale from "Pages/Product/Email Product/Flashsale";
import Ordersuccess from "Pages/Product/Email Product/Ordersuccess";
import Ordersuccess2 from "Pages/Product/Email Product/Ordersuccess2";

// Productdetails
import Productdetails from "Pages/Product/Productdetails";

// categories
import Categories from "Pages/Product/Categories";

// about
import About from "Pages/Product/About";

// Purchase Guide
import Purchaseguide from "Pages/Product/Purchaseguide";

// Terms of Conditions
import Termsconditions from "Pages/Product/Termsconditions";

// Privacy Policy
import Privacypolicy from "Pages/Product/Privacypolicy";

// Storelocator
import Storelocator from "Pages/Product/Storelocator";

// FAQ
import FAQ from "Pages/Product/FAQ";

// Invoice
import Invoice from "Pages/Product/Invoice";

// contact
import ContactUs from "Pages/ContactUs/Contact";

// ✅ add route type so TS knows "title"
export type AppRoute = {
  path: string;
  component: React.ReactElement;
  title?: string;
  isLight?: string;
};

const authProtectedRoutes: AppRoute[] = [
  // ✅ ROOT = TrendFashion (domain open)
  { path: "/", component: <TrendFashion />, title: "Home" },

  // other home layouts (optional)
  { path: "/dashboard", component: <Home />, title: "Dashboard" },
  { path: "/watch-main-layout", component: <Uniquewatch />, title: "Unique Watch" },
  { path: "/modern-fashion", component: <ModernFashion />, title: "Modern Fashion" },
  { path: "/trend-fashion", component: <TrendFashion />, title: "Trend Fashion" },

  // catalog
  { path: "/catalog/clothing", component: <Catalog />, title: "Catalog" },
  { path: "/product-list/left", component: <LeftsideBar />, title: "Product List" },
  { path: "/products-grid/right", component: <RightSidebar />, title: "Products" },
  { path: "/category/:categorySlug", component: <CmsCatalog />, title: "Category" },

  // shop
  { path: "/shop/address", component: <ShopIndex />, title: "Address" },
  { path: "/shop/order", component: <Trackorder />, title: "Track Order" },
  { path: "/shop/payment", component: <PaymentIndex />, title: "Payment" },
  { path: "/shop/review", component: <Review />, isLight: "light", title: "Review" },
  { path: "/shop/confirm", component: <Confirm />, title: "Confirm" },
  { path: "/shop/orderhistory", component: <Orderhistory />, title: "Order History" },
  { path: "/shop/shopingcard", component: <Shopingcard />, title: "Shopping Cart" },
  { path: "/shop/checkout", component: <Checkout />, title: "Checkout" },
  { path: "/shop/wishList", component: <WishList />, title: "Wishlist" },

  // product grid
  { path: "/products-grid/Default", component: <Defaultgrid />, title: "Products" },
  { path: "/products-grid/sidebar-banner", component: <ProductSidebar />, title: "Products" },
  { path: "/products-grid/right", component: <RightSidebar />, title: "Products" },
  { path: "/products-grid", component: <Nosider />, title: "Products" },

  // product list
  { path: "/product-list/defualt", component: <Listdefault />, title: "Product List" },
  { path: "/product-list/left", component: <LeftsideBar />, title: "Product List" },
  { path: "/product-list/right", component: <Leftrightsidebar />, title: "Product List" },
  { path: "/product-list", component: <Listnoslider />, title: "Product List" },

  // Productdetails
  { path: "/product/:slug", component: <Productdetails />, title: "Product" },

  // user
  { path: "/account", component: <MyAccount />, title: "My Account" },

  // categories
  { path: "/products-category", component: <Categories />, title: "Categories" },

  // about
  { path: "/about-us", component: <About />, title: "About" },

  // guides/policies
  { path: "/purchase-guide", component: <Purchaseguide />, title: "Purchase Guide" },
  { path: "/terms-conditions", component: <Termsconditions />, title: "Terms & Conditions" },
  { path: "/privacy-policy", component: <Privacypolicy />, title: "Privacy Policy" },

  // store locator
  { path: "/store-locator", component: <Storelocator />, title: "Store Locator" },

  // faq
  { path: "/ecommerce-faq", component: <FAQ />, title: "FAQ" },

  // invoice
  { path: "/invoice", component: <Invoice />, title: "Invoice" },
  { path: "/invoice/:orderId", component: <Invoice />, title: "Invoice" },

  // contact us
  { path: "/contact", component: <ContactUs />, title: "Contact" },

  // ✅ fallback
  { path: "*", component: <Navigate to="/" replace />, title: "Home" },
];

const publicRoutes: AppRoute[] = [
  { path: "/auth-signin-basic", component: <Signin />, title: "Sign In" },
  { path: "/auth-pass-reset-basic", component: <Passwordreset />, title: "Reset Password" },
  { path: "/auth-pass-change-basic", component: <Passwordcreate />, title: "Create Password" },
  { path: "/auth-success-msg-basic", component: <Successmsg />, title: "Success" },
  { path: "/auth-twostep-basic", component: <Verifyemail />, title: "Verify Email" },
  { path: "/auth-logout-basic", component: <Logout />, title: "Logout" },
  { path: "/auth-404", component: <Error404 />, title: "404" },
  { path: "/auth-500", component: <Error500 />, title: "500" },
  { path: "/coming-soon", component: <Comingsoon />, title: "Coming Soon" },
  
  // email
  { path: "/email-black-friday", component: <Blackfriday />, title: "Black Friday" },
  { path: "/email-flash-sale", component: <Flashsale />, title: "Flash Sale" },
  { path: "/email-order-success", component: <Ordersuccess />, title: "Order Success" },
  { path: "/email-order-success-2", component: <Ordersuccess2 />, title: "Order Success" },
];

export { authProtectedRoutes, publicRoutes };
